import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import ManualInvoice from 'components/Admin/Reports/ManualChargesReport/ManualChargesTable/ManualInvoice';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';


const ManualChargesTable = () => {
    const invoices = useSelector((state) => state.manualCharges.invoices);
    const trl = useTrls();

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <TableRow>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.invoiceId')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.createdAt')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.employerId')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.advertisingServiceType')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.productType')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.accountId')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.number')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.amount')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.discountAmount')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.clicks')}</TableHeadCell>
                    <TableHeadCell>{trl('admin.ManualChargesReport.Invoice.bonusClicks')}</TableHeadCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {invoices.map((invoice) => (
                    <ManualInvoice key={invoice.invoiceId} {...invoice} />
                ))}
            </TableBody>
        </Table>
    );
};

export default ManualChargesTable;
